import { graphHooks } from '@tunasong/graph-lib/react'
import { Lock } from '@tunasong/icons'
import type { FC } from 'react'
import { Link } from 'react-router'
import { Typography } from '../primitives/typography.js'
import { RequestAccessButton } from './request-access-button.js'
import { requestAccessCopy as copy } from './request-access-copy.js'
import styles from './locked-entity.module.css'

export interface LockedEntityProps {
  entityId: string
  variant: 'inline' | 'block'
  onHasAccess?: () => void
}

/**
 * The locked marker (request-access spec §8.1, §8.9). Nothing identifying: no stored title, snapshot, type or
 * owner. Inline it is a real link to the item route, where the denied page offers the request; while editing it
 * behaves like every other inline link (§8.9 #4). In an embed it is a fixed 56px row with the Request button,
 * never the snapshot's height, which would reveal the item's size.
 */
export const LockedEntity: FC<LockedEntityProps> = props => {
  const { entityId, variant, onHasAccess } = props
  const { data: mine } = graphHooks.useMyAccessRequest(variant === 'block' ? entityId : undefined)

  if (variant === 'inline') {
    return (
      <Link to={`/app/entities/${entityId}`} className={styles.inline} aria-label={copy.inlineAccessibleName}>
        <Lock size="1em" aria-hidden />
        {copy.inlineLabel}
      </Link>
    )
  }
  return (
    <div className={styles.block} contentEditable={false} data-locked="block">
      <Lock aria-hidden className={styles.icon} />
      <Typography variant="body2" className={styles.text}>
        {mine?.state === 'requested' ? copy.embedSent : copy.embedText}
      </Typography>
      <RequestAccessButton entityId={entityId} variant="outlined" layout="row" onHasAccess={onHasAccess} />
    </div>
  )
}
